import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { Injectable } from '@angular/core';
import { CellParserBase } from './cell-parser-base';
import { ClickableCell } from '../../models';
import { CardListCellTypes } from 'src/app/components/pages-partials/card-list/card-list-cell-types.enum';
import { CellActionHandlersService } from '../cell-action-handlers.service';
import { DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'src/app/services/settings.service';

@Injectable({ providedIn: 'root' })
export class ClickableCellParser extends CellParserBase {
  constructor(
      datePipe: DatePipe,
      decimalPipe: DecimalPipe,
      percentPipe: PercentPipe,
      translateService: TranslateService,
      settingsService: SettingsService,
      private cellLinkHandlersService: CellActionHandlersService) {
          super(datePipe, decimalPipe, percentPipe, translateService, settingsService);
      }
     
      public getLinkHrefHandler(cell: any) {  
        
        try{            
          if (!cell.actionType) return () => {};
          if (cell.actionType in this.cellLinkHandlersService === false) return () => {};
      
          return (response: { [x: string]: any }) => {
            
            let parameters = cell.actionParameters.map((parameter) => {              
              if (typeof parameter === 'string' && parameter.indexOf('{') !== -1) {
                const regex = /{(.*?)}/g;
                const found = parameter.match(regex);          
                let r = parameter;
                if(found) {
                  found.forEach(element => {
                    var value = this.getPropertyValue(element.replace('{', '').replace('}', ''), response);       
               
                    if (value?.toString().indexOf('T00:00:00') === 10) {
                      value = value.toString().substring(0,10);
                    }
                    r = r.replace(element, value);
                  });      
                }
                return r;   
              }        
              return parameter;
            });
            return parameters.join('/').replace("/?","?");
          };
        }
        catch{
          return () => {};
        }
    }

  private getLinkHandler(cell: any) {
 
    if (!cell.actionType) return () => {};

    if (cell.actionType in this.cellLinkHandlersService === false)
      throw new Error(
        `Action type "${cell.actionType}" not present in CellLinkHandlersService`
      );

    return (response:  any, event:any ) => {
      let parameters = cell.actionParameters.map((parameter) => {              
        if (typeof parameter === 'string' && parameter.indexOf('{') !== -1) {
          const regex = /{(.*?)}/g;
          const found = parameter.match(regex);          
          let r = parameter;
          if(found) {
            found.forEach(element => {
              var value = this.getPropertyValue(element.replace('{', '').replace('}', ''), response);
              if (value?.toString().indexOf('T00:00:00') === 10) {
                value = value.toString().substring(0,10);
              }
              r = r.replace(element, value);
            });      
          }
          return r;
        }        
        return parameter;
      });

      this.cellLinkHandlersService[cell.actionType].apply(
        this.cellLinkHandlersService,
        [event, ...parameters]        
      );
    };
  }

  parse(cell: ClickableCell): CardListCell {

    let textResolver = this.getTextResolver(cell);
    let csvResolver = this.getCsvResolver(cell);
    let linkHandler = this.getLinkHandler(cell);
    let hrefUrlHandler = this.getLinkHrefHandler(cell);

    return {
      type: CardListCellTypes.link,
      textResolver,
      csvResolver,
      class: cell.class,
      icon: cell.icon,
      title: cell.title,
      linkHandler,
      hrefResolver: hrefUrlHandler, 
      text: cell.overrideText,
      sortProperty: cell.sortProperty,
      sortDataType: cell.sortDataType
    };
  }
}
